import React, { createContext, useContext, useState, useEffect } from "react";

const STRINGS = {
  es: {
    appName: "Tourism AI",
    nav: { home: "Inicio", places: "Lugares", map: "Mapa", maps: "Mapas", itineraries: "Itinerarios", downloads: "Descargas", admin: "Admin" },
    hero: {
      kicker: "Guía turística inmersiva con IA",
      title: "Descubre lugares que te dejarán sin aliento",
      subtitle: "Explora hospitalidad, museos, atracciones, vida nocturna, rutas y mucho más. Pregúntale a nuestra guía IA.",
      searchPh: "Busca lugares, barrios, restaurantes...",
      askAI: "Preguntar a la guía IA",
      explore: "Explorar",
    },
    sections: {
      categories: "Explorar por categoría",
      featured: "Lugares destacados",
      featuredSub: "Selección curada para tu próxima visita",
      downloads: "Centro de descargas",
      downloadsSub: "Guías y mapas en PDF, listos para llevar",
      mapTitle: "Mapa interactivo",
      mapSub: "Mira todos los puntos de interés en un solo vistazo",
    },
    common: {
      viewAll: "Ver todo", viewDetails: "Ver detalles", download: "Descargar",
      back: "Atrás", schedule: "Horario", price: "Precio", address: "Dirección",
      website: "Web", phone: "Teléfono", noResults: "Sin resultados",
      filters: "Filtros", language: "Idioma", clear: "Limpiar",
      loading: "Cargando...", search: "Buscar",
    },
    ai: {
      title: "Guía IA",
      placeholder: "¿Qué te apetece descubrir hoy?",
      send: "Enviar",
      welcome: "¡Hola! Soy tu guía virtual. Pregúntame por rutas, restaurantes, museos o vida nocturna.",
      thinking: "Pensando...",
      recommended: "Lugares recomendados",
    },
    admin: {
      login: "Iniciar sesión",
      email: "Correo electrónico",
      password: "Contraseña",
      signin: "Acceder",
      logout: "Salir",
      dashboard: "Panel de control",
      stats: "Estadísticas",
      files: "Archivos",
      places: "Lugares",
      categories: "Categorías",
      uploadFile: "Subir archivo",
      addPlace: "Añadir lugar",
      title: "Título",
      description: "Descripción",
      delete: "Eliminar",
      edit: "Editar",
      save: "Guardar",
      cancel: "Cancelar",
    },
    languageNames: { es: "Español", en: "English", fr: "Français" },
  },
  en: {
    appName: "Tourism AI",
    nav: { home: "Home", places: "Places", map: "Map", maps: "Maps", itineraries: "Itineraries", downloads: "Downloads", admin: "Admin" },
    hero: {
      kicker: "Immersive AI travel guide",
      title: "Discover places that will take your breath away",
      subtitle: "Explore hospitality, museums, attractions, nightlife, routes and more. Ask our AI guide.",
      searchPh: "Search places, neighborhoods, restaurants...",
      askAI: "Ask the AI guide",
      explore: "Explore",
    },
    sections: {
      categories: "Browse by category",
      featured: "Featured places",
      featuredSub: "Curated picks for your next visit",
      downloads: "Download center",
      downloadsSub: "PDF guides and maps, ready to take with you",
      mapTitle: "Interactive map",
      mapSub: "See all points of interest at a glance",
    },
    common: {
      viewAll: "View all", viewDetails: "View details", download: "Download",
      back: "Back", schedule: "Hours", price: "Price", address: "Address",
      website: "Website", phone: "Phone", noResults: "No results",
      filters: "Filters", language: "Language", clear: "Clear",
      loading: "Loading...", search: "Search",
    },
    ai: {
      title: "AI Guide",
      placeholder: "What would you like to discover today?",
      send: "Send",
      welcome: "Hi! I'm your virtual guide. Ask me about routes, restaurants, museums or nightlife.",
      thinking: "Thinking...",
      recommended: "Recommended places",
    },
    admin: {
      login: "Sign in",
      email: "Email",
      password: "Password",
      signin: "Login",
      logout: "Logout",
      dashboard: "Dashboard",
      stats: "Statistics",
      files: "Files",
      places: "Places",
      categories: "Categories",
      uploadFile: "Upload file",
      addPlace: "Add place",
      title: "Title",
      description: "Description",
      delete: "Delete",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
    },
    languageNames: { es: "Español", en: "English", fr: "Français" },
  },
  fr: {
    appName: "Tourism AI",
    nav: { home: "Accueil", places: "Lieux", map: "Carte", maps: "Cartes", itineraries: "Itinéraires", downloads: "Téléchargements", admin: "Admin" },
    hero: {
      kicker: "Guide touristique immersif avec IA",
      title: "Découvrez des lieux qui vous laisseront sans voix",
      subtitle: "Explorez hospitalité, musées, attractions, vie nocturne, itinéraires et plus. Demandez à notre guide IA.",
      searchPh: "Cherchez lieux, quartiers, restaurants...",
      askAI: "Demander au guide IA",
      explore: "Explorer",
    },
    sections: {
      categories: "Parcourir par catégorie",
      featured: "Lieux phares",
      featuredSub: "Une sélection pour votre prochaine visite",
      downloads: "Centre de téléchargement",
      downloadsSub: "Guides et cartes PDF, prêts à emporter",
      mapTitle: "Carte interactive",
      mapSub: "Voyez tous les points d'intérêt en un coup d'œil",
    },
    common: {
      viewAll: "Voir tout", viewDetails: "Voir détails", download: "Télécharger",
      back: "Retour", schedule: "Horaires", price: "Prix", address: "Adresse",
      website: "Site web", phone: "Téléphone", noResults: "Aucun résultat",
      filters: "Filtres", language: "Langue", clear: "Effacer",
      loading: "Chargement...", search: "Rechercher",
    },
    ai: {
      title: "Guide IA",
      placeholder: "Que voulez-vous découvrir aujourd'hui ?",
      send: "Envoyer",
      welcome: "Bonjour ! Je suis votre guide virtuelle. Demandez-moi des itinéraires, restaurants, musées ou vie nocturne.",
      thinking: "Réflexion...",
      recommended: "Lieux recommandés",
    },
    admin: {
      login: "Connexion",
      email: "Email",
      password: "Mot de passe",
      signin: "Se connecter",
      logout: "Déconnexion",
      dashboard: "Tableau de bord",
      stats: "Statistiques",
      files: "Fichiers",
      places: "Lieux",
      categories: "Catégories",
      uploadFile: "Téléverser",
      addPlace: "Ajouter un lieu",
      title: "Titre",
      description: "Description",
      delete: "Supprimer",
      edit: "Modifier",
      save: "Enregistrer",
      cancel: "Annuler",
    },
    languageNames: { es: "Español", en: "English", fr: "Français" },
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "es");
  useEffect(() => { localStorage.setItem("lang", lang); }, [lang]);
  const t = STRINGS[lang] || STRINGS.es;
  // Helper to get localized field from i18n object
  const tx = (obj) => {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    return obj[lang] || obj.es || obj.en || obj.fr || "";
  };
  return (
    <I18nContext.Provider value={{ lang, setLang, t, tx, available: ["es", "en", "fr"] }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
